import { ITrackAddNewFlatByNumberParameters, trackAddNewMyHomeObject } from './tracking';
import { EMyHomeEstimationTargets } from '../types/estimationTarget';
import { IFormFields } from '../types/formFields';

interface IUseGetTrackAddMyHomeObjectProps {
  isSubmit?: boolean;
  estimationTarget: EMyHomeEstimationTargets;
  filters: IFormFields;
}

export const useGetTrackAddMyHomeObject = ({
  estimationTarget,
  filters,
  isSubmit,
}: IUseGetTrackAddMyHomeObjectProps) => {
  const { roomsCount, area, userSetArea, userSetRoomsCount, address, flatNumber, landArea } = filters;

  const parameters: ITrackAddNewFlatByNumberParameters = {
    result: {
      address,
      flatnumber: flatNumber,
      roomsnumber: roomsCount,
      area,
      landarea: landArea,
    },
  };

  if (estimationTarget === EMyHomeEstimationTargets.flat) {
    parameters['autofiiled'] = {
      roomsnumber: !userSetRoomsCount ? roomsCount : undefined,
      area: !userSetArea ? area : undefined,
    };
  }

  return () =>
    trackAddNewMyHomeObject({
      label: isSubmit ? 'EstateCalculatorSuccess' : 'EstateCalculator',
      estimationTarget,
      parameters,
    });
};
